type ScrollOptions = { duration?: number };
type ScrollCallback = (err: null, value: number) => void;

const inOutSine = (n: number): number => 0.5 * (1 - Math.cos(Math.PI * n));
const noop = (): void => {};

const makeScroll =
  (prop: string) =>
  (
    el: HTMLElement,
    to: number,
    opts?: ScrollOptions | ScrollCallback | null | undefined,
    cb?: ScrollCallback
  ): number => {
    const element = el as HTMLElement & Record<string, number>;
    let callback: ScrollCallback | typeof noop = cb as ScrollCallback;
    const options = opts || {};
    const start = Date.now();
    const from = element[prop];
    const ease = inOutSine;
    const duration = Number.isInteger((options as ScrollOptions).duration)
      ? (options as ScrollOptions).duration!
      : 350;
    const requestAnimationFrameCallback = (): void => {
      (callback as ScrollCallback)(null, element[prop]);
    };
    const animate = () => {
      const now = Date.now();
      const time = Math.min(1, (now - start) / duration);
      const eased = ease(time);

      element[prop] = eased * (to - from) + from;

      return time < 1
        ? requestAnimationFrame(animate)
        : requestAnimationFrame(requestAnimationFrameCallback);
    };

    if (typeof opts === 'function') callback = options as ScrollCallback;
    if (typeof cb !== 'function') callback = noop;

    return requestAnimationFrame(animate);
  };
export const scrollTop = makeScroll('scrollTop');
